import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/pages/layout/index'
import { newRouter } from './router.js'
/* Layout */
import Layout from '@/pages/layout'
Vue.use(Router)

const constantRouter = [
  /** 处理头部右键刷新功能 使用重定向来实现 当key改变时候页面app-main加载 */
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/pages/redirect/index')
      }
    ]
  },
  { path: '/', redirect: '/home', hidden: true },
  // 404页面
  {
    path: '/404',
    component: () => import('@/pages/redirect/404'),
    hidden: true
  },
  // 登录
  {
    path: '/login',
    Name: 'Login',
    component: resolve => require(['@/pages/login/index'], resolve)
  },
  // 注册（独立页面，账号改造 feat-jri/account-redesign）
  {
    path: '/register',
    name: 'Register',
    component: resolve => require(['@/pages/register/index'], resolve),
    meta: { noAuth: true }
  },
  // 忘记密码
  {
    path: '/forget-password',
    name: 'ForgetPassword',
    component: resolve => require(['@/pages/forgetPassword/index'], resolve),
    meta: { noAuth: true }
  },
  // 重置密码（通过邮件 token 进入）
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: resolve => require(['@/pages/forgetPassword/reset'], resolve),
    meta: { noAuth: true }
  },
  // 首次登录强制改密
  {
    path: '/force-change-password',
    name: 'ForceChangePassword',
    component: resolve => require(['@/pages/forgetPassword/forceChange'], resolve),
    meta: { noAuth: true }
  },
  // 邮箱修改验证码页（新标签页打开）
  {
    path: '/email-verify',
    name: 'EmailVerify',
    component: resolve => require(['@/pages/emailVerify/index'], resolve),
    meta: { noAuth: true }
  },
  // 主面板内容 剔除以前的人写法 改用分模块管理 author:brian date:2022 06 01
  {
    path: '/layout',
    name: 'Layout',
    component: layout,
    meta: { title: 'dashboard', icon: 'dashboard', affix: true },
    children: [
      { ...newRouter.home },
      { ...newRouter.personal },
      { ...newRouter.carrier },
      { ...newRouter.application },
      { ...newRouter.exception },
      { ...newRouter.device },
      { ...newRouter.account },
      { ...newRouter.log },
      { ...newRouter.sys },
      { ...newRouter.databoard },
      { ...newRouter.count },
      { ...newRouter.code }
    ]
  },
  ...newRouter.win,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]
export default new Router({
  mode: 'history',
  // Support sub-path deployment: base must match publicPath so vue-router
  // generates correct URLs (e.g. /<branch>/home instead of /home).
  // VUE_APP_PUBLIC_PATH is set by Dockerfile build arg BRANCH.
  base: process.env.VUE_APP_PUBLIC_PATH || '/',
  // mode: routerModel,
  routes: constantRouter
})
